(() => {
  const roots = document.querySelectorAll('[data-peak-product-guide]');
  if (!roots.length) return;

  const CORE_SAFETY_PATTERN = /\b(pregnan\w*|breast[ -]?feed\w*|nursing|child|children|kid|teen|under[ -]?18|baby|infant|medication\w*|medicine\w*|medical|prescription|drug|condition|diagnos\w*|disease|disorder|ulcer\w*|allerg\w*|anaphyl\w*|intoleran\w*|diabet\w*|blood pressure|thyroid|pcos|cancer|arthritis|migraine|menopaus\w*|ibs|ibd|coeliac|celiac|hypertension|cholesterol|fertility|hormone\w*|warfarin|metformin|insulin|ibuprofen|paracetamol|acetaminophen|ramipril|statin\w*|antibiotic\w*|antidepressant\w*|ssri\w*|aspirin|blood thinner\w*|contracepti\w*)\b/i;
  const ABDOMINAL_CONTEXT_PATTERN = /\b(belly|tummy|stomach|abdom(?:en|inal)|pain|ache|discomfort)\b/i;
  const URGENT_MODIFIER_PATTERN = /\b(severe|sudden|unbearable|excruciating|sharp|locali[sz]ed|worsening|getting worse|persistent|dizzy|fever|high temperature)\b/i;
  const URGENT_STANDALONE_PATTERN = /\b(bleed\w*|blood in (?:my |the )?(?:poo|stool)|bloody (?:poo|stool)|(?:black|maroon)(?:,? (?:tarry|sticky))? (?:poo|stool)|vomit(?:ing|ed)? (?:up )?blood|coffee[- ]ground vomit\w*|faint\w*|collapse\w*|repeated(?:ly)? vomit\w*|can(?:not|['’]t) (?:poo|fart|pee|breathe)|trouble breathing|shortness of breath|chest pain|hurts? (?:when )?(?:i )?touch\w*)\b/i;
  const URGENT_DURATION_PATTERN = /\b(pain|ache|discomfort)\b.{0,32}\b(?:for|over) (?:\d+|one|two|three|four|five|six|seven|eight|nine|ten|several|a few) (?:hours?|days?|weeks?)\b/i;
  const URGENT_RETURNING_PATTERN = /\b(pain|ache|discomfort)\b.{0,40}\b(?:keeps? (?:coming back|returning)|recurr(?:ing|ent)|won['’]?t go away|doesn['’]?t settle|not settling)\b/i;
  const DIRECT_MEDICAL_ADVICE_PATTERN = /\b(symptom\w*|dose|dosage|how (?:much|many) (?:should|can|do) i take|take together|stack|combine with|stop taking|treat|cure|prevent|heal|reverse|therapy|helps? with|good for|best for|what (?:can|should) i take for|recommend\w*(?: me)? (?:something )?for)\b/i;
  const OTHER_SYMPTOM_PATTERN = /\b(depress\w*|anxiet\w*|panic|brain fog|memory loss|can(?:not|['’]t) sleep|trouble sleeping|insomnia|sleepless\w*|diarrh\w*|nause\w*|vomit\w*|headache\w*|fatigue|tiredness|exhaust\w*|weight loss|lose weight)\b/i;
  const MILD_DIGESTIVE_BROWSE_PATTERN = /^(?:(?:(?:is there )?(?:anything|something)|what (?:product|supplement|anything)) (?:that )?(?:can|could|will|might|may|would)? ?helps? (?:me )?(?:with|for) |(?:do you have|show me|i(?:'m| am) looking for) (?:anything|something|a product|a supplement) (?:for|to help with) )?(?:(?:i (?:have|have got|feel|am experiencing)|i['’]ve got|my) )?(?:a )?(?:mild )?(?:(?:belly|tummy|stomach|abdominal) (?:ache|pain|discomfort)|(?:belly|tummy|stomach) aches?|bloated|bloating|constipated|constipation|indigestion|heartburn|reflux)(?: (?:today|recently|sometimes))?[.!?]*$/i;
  const LIFESTYLE_BROWSE_PATTERN = /\b(groggy|mornings?|morning routine|energy|everyday|daily routine)\b/i;
  const guidedBrowseTopic = (message) => MILD_DIGESTIVE_BROWSE_PATTERN.test(message.trim()) ? 'digestion' : null;
  const lifestyleBrowseTopic = (message) => LIFESTYLE_BROWSE_PATTERN.test(message) ? 'everyday' : null;
  const needsUrgentRedirect = (message) => URGENT_STANDALONE_PATTERN.test(message)
    || URGENT_DURATION_PATTERN.test(message)
    || URGENT_RETURNING_PATTERN.test(message)
    || (ABDOMINAL_CONTEXT_PATTERN.test(message) && URGENT_MODIFIER_PATTERN.test(message));
  const needsMedicalRedirect = (message) => needsUrgentRedirect(message)
    || (!guidedBrowseTopic(message) && (
      CORE_SAFETY_PATTERN.test(message)
      || DIRECT_MEDICAL_ADVICE_PATTERN.test(message)
      || OTHER_SYMPTOM_PATTERN.test(message)
      || /\bpain\b/i.test(message)
    ));

  const CATALOGUE = [
    { handle: 'multivitamin-gummies', topics: ['general', 'everyday', 'womens'], format: 'gummies', vegan: false, priority: 1, keywords: ['multivitamin', 'gummy', 'gummies'], reason: '60 gummies from the Everyday Essentials range.' },
    { handle: 'acai', topics: ['general', 'botanicals'], format: 'capsules', vegan: true, priority: 2, keywords: ['acai'], reason: '100 capsules; suitable for vegans.' },
    { handle: 'turmeric-blend', topics: ['general', 'botanicals'], format: 'capsules', vegan: true, priority: 3, keywords: ['turmeric'], reason: '90 capsules; suitable for vegans.' },
    { handle: 'apple-cider-vinegar', topics: ['general', 'botanicals'], format: 'capsules', vegan: true, priority: 4, keywords: ['apple cider vinegar', 'acv'], reason: '120 capsules; suitable for vegans.' },
    { handle: 'cherry-beet-blend', topics: ['general', 'botanicals'], format: 'capsules', vegan: true, priority: 5, keywords: ['cherry', 'beet', 'beetroot'], reason: '60 capsules; suitable for vegans.' },
    { handle: 'collagen-beauty', topics: ['general', 'beauty', 'womens'], format: 'capsules', vegan: false, priority: 6, keywords: ['collagen', 'beauty'], reason: '60 capsules from the Women’s Wellness range; contains fish.' },
    { handle: 'lion-s-mane', topics: ['general', 'botanicals'], format: 'capsules', vegan: true, priority: 6.5, keywords: ['lion’s mane', "lion's mane", 'lions mane'], reason: '90 capsules; suitable for vegans.' },
    { handle: 'ashwagandha', topics: ['general', 'botanicals'], format: 'capsules', vegan: true, priority: 7, keywords: ['ashwagandha', 'ksm-66', 'ksm66'], reason: '90 capsules; suitable for vegans.' },
    { handle: 'green-superfood', topics: ['general', 'botanicals'], format: 'powder', vegan: true, priority: 8, keywords: ['green superfood', 'greens', 'superfood'], reason: '300g powder; suitable for vegans.' },
    { handle: 'fibre', topics: ['general', 'digestion'], format: 'powder', vegan: true, priority: 9, keywords: ['fibre powder', 'fiber powder', 'glucomannan'], reason: '180g fibre powder; suitable for vegans.' },
    { handle: 'fibre-blend', topics: ['general', 'digestion'], format: 'capsules', vegan: true, priority: 10, keywords: ['fibre capsule', 'fiber capsule', 'psyllium'], reason: '100 fibre capsules; suitable for vegans.' },
    { handle: 'maca', topics: ['general', 'botanicals', 'womens'], format: 'capsules', vegan: true, priority: 11, keywords: ['maca'], reason: '90 capsules; suitable for vegans.' },
    { handle: 'creatine', topics: ['general', 'training'], format: 'powder', vegan: true, priority: 11.5, keywords: ['creatine', 'creatine monohydrate'], reason: '500g creatine monohydrate powder; suitable for vegans.' },
    { handle: 'pea-protein', topics: ['general', 'training'], format: 'powder', vegan: true, priority: 12, keywords: ['pea protein', 'plant protein', 'vegan protein'], reason: '500g plant protein powder; suitable for vegans.' },
    { handle: 'vitamin-c', topics: ['general', 'everyday'], format: 'capsules', vegan: true, priority: 13, keywords: ['vitamin c'], reason: '60 capsules; suitable for vegans.' },
    { handle: 'night-support', topics: ['evening'], format: 'capsules', vegan: true, priority: 14, keywords: ['night support', 'evening', 'night'], reason: '60 capsules from the evening range; suitable for vegans.' },
    { handle: 'electrolyte-hydration', topics: ['training'], format: 'powder', vegan: true, priority: 15, keywords: ['electrolyte', 'hydration'], reason: '540g hydration powder; suitable for vegans.' },
    { handle: 'protein-chocolate', topics: ['training'], format: 'powder', vegan: false, priority: 16, keywords: ['chocolate protein', 'whey chocolate'], reason: '600g chocolate protein powder; contains milk and soya.' },
    { handle: 'protein-vanilla', topics: ['training'], format: 'powder', vegan: false, priority: 17, keywords: ['vanilla protein', 'whey vanilla'], reason: '600g vanilla protein powder; contains milk and soya.' },
    { handle: 'muscle-strength-bundle', topics: ['bundles'], format: 'bundle', vegan: false, priority: 18, keywords: ['muscle bundle', 'strength bundle', 'vanilla bundle'], reason: 'Five full-size products in the Vanilla edition; compare every component label before purchase.', imageKey: 'muscle' },
    { handle: 'muscle-strength-bundle-chocolate', topics: [], format: 'bundle', vegan: false, priority: 18.5, keywords: ['chocolate muscle bundle', 'chocolate strength bundle'], reason: 'Five full-size products in the Chocolate edition; compare every component label before purchase.', imageKey: 'muscleChocolate' },
    { handle: 'women-s-wellness-bundle', topics: ['bundles'], format: 'bundle', vegan: false, priority: 19, keywords: ['women bundle', 'wellness bundle'], reason: 'Five full-size products; compare every component label before purchase.', imageKey: 'womens' },
    { handle: 'total-body-reset-bundle', topics: ['bundles'], format: 'bundle', vegan: false, priority: 20, keywords: ['reset bundle', 'total body bundle', 'detox bundle'], reason: 'Five full-size products; compare every component label before purchase.', imageKey: 'reset' },
  ];

  const normalizeSearch = (value) => String(value)
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  })[character]);

  const money = (cents) => new Intl.NumberFormat('en-GB', {
    style: 'currency', currency: 'GBP', minimumFractionDigits: 2,
  }).format(cents / 100);

  const track = (action, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'peak_product_guide', guide_action: action, ...detail });
  };

  const localIntent = (message) => {
    const text = message.toLowerCase();
    if (needsMedicalRedirect(text)) return { state: 'medical_redirect', topic: 'general', format: 'any', vegan: 'any', budget_max: null };

    const guidedTopic = guidedBrowseTopic(text);
    if (guidedTopic) return { state: 'results', topic: guidedTopic, format: 'any', vegan: 'any', budget_max: null };

    const lifestyleTopic = lifestyleBrowseTopic(text);
    if (lifestyleTopic) return { state: 'results', topic: lifestyleTopic, format: 'any', vegan: 'any', budget_max: null };

    let topic = 'general';
    if (/bundle|save|offer|deal/.test(text)) topic = 'bundles';
    else if (/evening|night|sleep/.test(text)) topic = 'evening';
    else if (/beauty|collagen|skin/.test(text)) topic = 'beauty';
    else if (/training|workout|gym|protein|electrolyte|sport/.test(text)) topic = 'training';
    else if (/fibre|fiber|biotic|digestion|digestive|gut/.test(text)) topic = 'digestion';
    else if (/women|woman|female/.test(text)) topic = 'womens';
    else if (/botanical|herb|turmeric|ashwagandha|maca|acai|cherry|beet/.test(text)) topic = 'botanicals';
    else if (/everyday|vitamin|gumm/.test(text)) topic = 'everyday';

    let format = 'any';
    if (/powder|shake/.test(text)) format = 'powder';
    else if (/gumm/.test(text)) format = 'gummies';
    else if (/capsule|tablet/.test(text)) format = 'capsules';

    const vegan = /vegan|plant[- ]?based/.test(text) ? 'required' : 'any';
    const budgetMatch = text.match(/(?:under|below|less than|max(?:imum)?|budget(?: of)?)\s*£?\s*(\d{1,3})/);
    let budgetMax = null;
    if (budgetMatch) {
      const amount = Number(budgetMatch[1]);
      budgetMax = amount >= 30 ? 30 : amount >= 20 ? 20 : 15;
    }

    const hasPreference = topic !== 'general' || format !== 'any' || vegan === 'required' || budgetMax !== null
      || CATALOGUE.some((item) => item.keywords.some((keyword) => text.includes(keyword)));
    return {
      state: 'results', topic, format, vegan, budget_max: budgetMax, fallback_popular: !hasPreference,
    };
  };

  roots.forEach((root) => {
    const ui = root.querySelector('[data-peak-guide-ui]');
    if (!ui) return;

    const log = ui.querySelector('[data-guide-log]');
    const form = ui.querySelector('[data-guide-form]');
    const input = ui.querySelector('[data-guide-input]');
    const submit = ui.querySelector('[data-guide-submit]');
    const quick = ui.querySelector('[data-guide-quick]');
    const endpoint = root.dataset.endpoint;
    const shopAllUrl = root.dataset.shopAllUrl || '/collections/all';
    const bundleImages = {
      muscle: root.dataset.muscleImage,
      muscleChocolate: root.dataset.muscleChocolateImage,
      womens: root.dataset.womensImage,
      reset: root.dataset.resetImage,
    };
    let storefrontIndexPromise;

    const loadStorefrontIndex = () => {
      if (!storefrontIndexPromise) {
        storefrontIndexPromise = fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } })
          .then((response) => response.ok ? response.json() : { products: [] })
          .then((payload) => Array.isArray(payload.products) ? payload.products.map((product) => ({
            handle: String(product.handle || ''),
            title: String(product.title || ''),
          })).filter((product) => product.handle && product.title) : [])
          .catch(() => []);
      }
      return storefrontIndexPromise;
    };

    const findExactCatalogueMatches = async (message) => {
      const normalizedMessage = ` ${normalizeSearch(message)} `;
      const products = await loadStorefrontIndex();
      return products
        .filter((product) => {
          const title = normalizeSearch(product.title);
          const handle = normalizeSearch(product.handle);
          return title.length >= 4 && (normalizedMessage.includes(` ${title} `) || normalizedMessage.includes(` ${handle} `));
        })
        .map((product) => CATALOGUE.find((item) => item.handle === product.handle) || {
          handle: product.handle,
          topics: ['general'],
          format: 'any',
          vegan: false,
          priority: 0,
          keywords: [],
          reason: 'Exact catalogue match. Check the full ingredients and warnings.',
        })
        .slice(0, 3);
    };

    const scrollToLatest = () => {
      requestAnimationFrame(() => {
        const conversation = log.parentElement;
        const overflow = getComputedStyle(conversation).overflowY;
        if ((overflow === 'auto' || overflow === 'scroll') && conversation.scrollHeight > conversation.clientHeight + 8) {
          conversation.scrollTo({ top: conversation.scrollHeight, behavior: 'smooth' });
        }
      });
    };

    const addMessage = (type, html, extraClass = '') => {
      const article = document.createElement('article');
      article.className = `peak-guide__message peak-guide__message--${type} ${extraClass}`.trim();
      article.innerHTML = html;
      log.appendChild(article);
      scrollToLatest();
      return article;
    };

    const addUserMessage = (message) => addMessage('user', `<p>${escapeHtml(message)}</p>`);
    const addThinking = () => addMessage('assistant', '<p><span class="peak-guide__typing"><i></i><i></i><i></i></span><span class="visually-hidden">Comparing products</span></p>', 'peak-guide__message--thinking');

    const fetchProduct = async (item) => {
      try {
        const response = await fetch(`/products/${item.handle}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        const product = await response.json();
        if (!product.available) return null;
        return {
          ...item,
          title: product.title,
          price: product.price,
          compareAt: product.compare_at_price,
          url: product.url || `/products/${item.handle}`,
          image: product.featured_image || bundleImages[item.imageKey] || '',
        };
      } catch (_error) {
        return null;
      }
    };

    const popularIntent = {
      state: 'results',
      topic: 'general',
      format: 'any',
      vegan: 'any',
      budget_max: null,
      fallback_popular: true,
    };

    const showMedicalRedirect = async (message) => {
      if (needsUrgentRedirect(message)) {
        addMessage('assistant', '<p>This may need medical help rather than a supplement. Use <a href="https://111.nhs.uk/">NHS 111</a> if it’s getting worse or not settling. For sudden or severe pain or another emergency warning sign, call 999 or go to A&amp;E. If you also want to browse, the product below is a catalogue suggestion only—not a match for the symptoms you described.</p>');
        track('urgent_redirect');
      } else {
        addMessage('assistant', '<p>I can’t assess which supplement is personally suitable from health details alone. You can still browse the product below as a general catalogue suggestion; check its full label and ask a pharmacist or doctor before using it.</p>');
        track('medical_redirect');
      }

      await showResults(popularIntent, '', true);
    };

    const showClarify = async () => {
      addMessage('assistant', '<p>Here’s a popular product to start with. You can narrow this down by asking for protein, capsules, vegan products or a price limit.</p>');
      if (quick) quick.hidden = false;
      track('clarify');
      await showResults(popularIntent, '', true);
    };

    const showNoResults = () => {
      addMessage('assistant', `<p>I couldn’t find a verified match for all of those filters. Try removing one filter or <a href="${escapeHtml(shopAllUrl)}">browse every product label</a>.</p>`);
      track('no_results');
    };

    async function showResults(intent, rawMessage, isFallback = false) {
      const text = rawMessage.toLowerCase();
      const exact = (await findExactCatalogueMatches(rawMessage)).filter((item) => (
        (intent.format === 'any' || item.format === intent.format)
        && (intent.vegan !== 'required' || item.vegan)
      ));
      const direct = CATALOGUE.filter((item) => item.keywords.some((keyword) => text.includes(keyword)));
      const popular = ['creatine', 'lion-s-mane', 'collagen-beauty']
        .map((handle) => CATALOGUE.find((item) => item.handle === handle))
        .filter(Boolean);
      const aiRanked = Array.isArray(intent.ranked_products)
        ? intent.ranked_products.map((match, index) => {
          const item = CATALOGUE.find((product) => product.handle === match.handle);
          return item ? { ...item, priority: index - 100 } : null;
        }).filter(Boolean)
        : [];
      let candidates = aiRanked.length
        ? aiRanked
        : exact.length
        ? exact
        : direct.length
        ? direct
        : intent.fallback_popular
        ? popular
        : CATALOGUE.filter((item) => intent.topic === 'general' ? item.topics.includes('general') : item.topics.includes(intent.topic));

      if (intent.topic !== 'bundles') candidates = candidates.filter((item) => item.format !== 'bundle');
      if (intent.format !== 'any') candidates = candidates.filter((item) => item.format === intent.format);
      if (intent.vegan === 'required') candidates = candidates.filter((item) => item.vegan);
      if (!intent.fallback_popular && !aiRanked.length) candidates.sort((a, b) => a.priority - b.priority);

      const liveProducts = (await Promise.all(candidates.slice(0, 10).map(fetchProduct))).filter(Boolean);
      const budgetProducts = intent.budget_max
        ? liveProducts.filter((product) => product.price <= intent.budget_max * 100)
        : liveProducts;
      const products = budgetProducts.slice(0, 3);
      if (!products.length) {
        if (!isFallback) return showResults(popularIntent, '', true);
        return showNoResults();
      }

      const filterLabels = [];
      if (intent.topic && intent.topic !== 'general') filterLabels.push(intent.topic.replace('womens', 'women’s'));
      if (intent.format && intent.format !== 'any') filterLabels.push(intent.format);
      if (intent.vegan === 'required') filterLabels.push('vegan suitable');
      if (intent.budget_max) filterLabels.push(`up to £${intent.budget_max}`);
      const filterSummary = filterLabels.length
        ? `<p class="peak-guide__filters">Compared: ${filterLabels.map(escapeHtml).join(' · ')}</p>`
        : '';

      const cards = products.map((product) => {
        const sale = product.compareAt && product.compareAt > product.price
          ? `<s>${money(product.compareAt)}</s> `
          : '';
        const image = product.image
          ? `<img src="${escapeHtml(product.image.startsWith('//') ? `https:${product.image}` : product.image)}" alt="" width="120" height="120" loading="lazy">`
          : '';
        return `<article class="peak-guide__result">
          <a class="peak-guide__result-media" href="${escapeHtml(product.url)}" tabindex="-1" aria-hidden="true">${image}</a>
          <div>
            <h4><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h4>
            <p>${escapeHtml(product.reason)}</p>
            <div class="peak-guide__result-footer"><span>${sale}<strong>${money(product.price)}</strong></span><a href="${escapeHtml(product.url)}" data-guide-product="${escapeHtml(product.handle)}">View label →</a></div>
          </div>
        </article>`;
      }).join('');

      const guidedDigestiveBrowse = guidedBrowseTopic(rawMessage) === 'digestion';
      const intro = isFallback
        ? '<p>Product suggestion:</p>'
        : guidedDigestiveBrowse
        ? '<p>Here are our digestion products to compare for general nutrition. I can’t assess whether either is suitable for an unexplained ache, and they aren’t treatments for stomach pain. Check the ingredients, directions and warnings before choosing.</p>'
        : '<p>Based on what you said, these are the closest Peak products to compare. Open one to check the full ingredients and directions.</p>';

      addMessage('assistant', `${intro}${filterSummary}<div class="peak-guide__results">${cards}</div>`);
      track('results_shown', { result_count: products.length, guide_topic: intent.topic, guided_browse: guidedDigestiveBrowse });
    }

    const mergeExplicitFilters = (remoteIntent, local) => {
      if (!remoteIntent || remoteIntent.state === 'medical_redirect' || local.state !== 'results') {
        return remoteIntent || local;
      }
      const topic = local.topic !== 'general' ? local.topic : remoteIntent.topic;
      const format = local.format !== 'any' ? local.format : remoteIntent.format;
      const vegan = local.vegan === 'required' ? 'required' : remoteIntent.vegan;
      const budgetMax = local.budget_max !== null ? local.budget_max : remoteIntent.budget_max;
      return {
        ...remoteIntent,
        state: 'results',
        topic,
        format,
        vegan,
        budget_max: budgetMax,
        ranked_products: Array.isArray(remoteIntent.ranked_products) ? remoteIntent.ranked_products : [],
        shopper_summary: typeof remoteIntent.shopper_summary === 'string' ? remoteIntent.shopper_summary : '',
        fallback_popular: Boolean(local.fallback_popular
          && topic === 'general' && format === 'any' && vegan === 'any' && budgetMax === null),
      };
    };

    const classify = async (message) => {
      if (needsMedicalRedirect(message) || guidedBrowseTopic(message)) return localIntent(message);
      if (!endpoint) return localIntent(message);
      const explicitIntent = localIntent(message);
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ message }),
        });
        if (!response.ok) throw new Error('Guide endpoint unavailable');
        const payload = await response.json();
        return mergeExplicitFilters(payload.intent, explicitIntent);
      } catch (_error) {
        return explicitIntent;
      }
    };

    const handleMessage = async (message, presetIntent = null) => {
      const trimmed = message.replace(/\s+/g, ' ').trim().slice(0, 180);
      if (trimmed.length < 2 || submit.disabled) return;
      submit.disabled = true;
      if (quick) quick.hidden = true;
      addUserMessage(trimmed);
      const thinking = addThinking();
      const intent = presetIntent || await classify(trimmed);
      thinking.remove();

      if (intent.state === 'medical_redirect') await showMedicalRedirect(trimmed);
      else if (intent.state === 'clarify') await showClarify();
      else await showResults(intent, presetIntent ? '' : trimmed);

      submit.disabled = false;
      input.focus({ preventScroll: true });
      track(presetIntent ? 'quick_choice' : 'free_text_classified');
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const message = input.value;
      input.value = '';
      handleMessage(message);
    });

    if (quick) {
      quick.addEventListener('click', (event) => {
        const button = event.target.closest('[data-guide-topic]');
        if (!button) return;
        const topic = button.dataset.guideTopic;
        handleMessage(button.textContent.trim(), {
          state: 'results', topic, format: 'any', vegan: 'any', budget_max: null,
        });
      });
    }

    log.addEventListener('click', (event) => {
      const link = event.target.closest('[data-guide-product]');
      if (link) track('product_clicked', { product_handle: link.dataset.guideProduct });
    });

    track('loaded');
  });
})();
